import {
    IonButton,
    IonContent,
    IonHeader,
    IonIcon,
    IonInput,
    IonItem,
    IonLabel,
    IonPage,
    IonProgressBar,
    IonSelect,
    IonSelectOption,
    IonSpinner,
    IonTitle,
    IonToolbar,
    useIonRouter,
    useIonToast
} from "@ionic/react";
import {
    arrowBackOutline,
    arrowForwardOutline,
    calendarOutline,
    checkmarkCircleOutline,
    americanFootballOutline,
    lockClosedOutline,
    peopleOutline,
    settingsOutline,
    trophyOutline
} from "ionicons/icons";
import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";

import Cookies from "js-cookie";
import "./CreateLeague.css";

const CreateLeague: React.FC = () => {
    const router = useIonRouter();
    const history = useHistory();

    const [present] = useIonToast();

    const [fantasy, setFantasy] = useState("");
    const [leagueName, setLeagueName] = useState("");
    const [leaguePassword, setLeaguePassword] = useState("");
    const [teamName, setTeamName] = useState("");

    const [timePick, setTimePick] = useState("30");
    const [draftFormat, setDraftFormat] = useState("stand");
    const [draftDay, setDraftDay] = useState("");
    const [draftTime, setDraftTime] = useState("18");
    const [draftOrder, setDraftOrder] = useState("snake");
    const [totalTeams, setTotalTeams] = useState("8");
    const [playoffs, setPlayoffs] = useState("4");

    const [submitting, setSubmitting] = useState(false);

    function getAccessToken(): string {
        return Cookies.get("access_token") || "";
    }

    function getAccessUser(): string {
        return Cookies.get("access_user") || "";
    }

    function getAccessUsername(): string {
    return (
        Cookies.get("access_username") ||
        Cookies.get("access_user") ||
        ""
    );
}

function isAuthenticated(): boolean {
    return Boolean(
        Cookies.get("access_token") &&
        Cookies.get("access_username")
    );
}


    function showToast(
        message: string,
        color: "success" | "danger" | "warning"
    ) {
        present({
            message,
            duration: 2500,
            position: "bottom",
            color,
            buttons: [
                {
                    text: "Cerrar",
                    role: "cancel"
                }
            ]
        });
    }

    function isValidText(value: string): boolean {
        return /^[a-zA-ZáéíóúÁÉÍÓÚñÑ0-9 ]+$/.test(value);
    }

    function getTodayDate(): string {
    const now = new Date();

    const year = now.getFullYear();

    const month = String(
        now.getMonth() + 1
    ).padStart(2, "0");

    const day = String(
        now.getDate()
    ).padStart(2, "0");

    return `${year}-${month}-${day}`;
}

    function validateForm(): boolean {
        if (!fantasy) {
            showToast(
                "Selecciona la competencia para tu liga.",
                "warning"
            );

            return false;
        }

        if (!leagueName.trim() || !teamName.trim()) {
            showToast(
                "Ingresa el nombre de la liga y el nombre de tu equipo.",
                "warning"
            );

            return false;
        }

        if (!leaguePassword.trim()) {
            showToast(
                "Ingresa una contraseña para la liga.",
                "warning"
            );

            return false;
        }

        if (
            leagueName.trim().length > 20 ||
            leaguePassword.trim().length > 20 ||
            teamName.trim().length > 20
        ) {
            showToast(
                "Los nombres y la contraseña deben tener máximo 20 caracteres.",
                "warning"
            );

            return false;
        }

        if (
            !isValidText(leagueName.trim()) ||
            !isValidText(leaguePassword.trim()) ||
            !isValidText(teamName.trim())
        ) {
            showToast(
                "Usa únicamente letras, números y espacios.",
                "warning"
            );

            return false;
        }

        if (!draftDay) {
            showToast(
                "Selecciona la fecha del draft.",
                "warning"
            );

            return false;
        }

        if (draftDay < getTodayDate()) {
            showToast(
                "La fecha del draft no puede ser anterior a hoy.",
                "warning"
            );

            return false;
        }

        if (Number(playoffs) > Number(totalTeams)) {
            showToast(
                "La cantidad de equipos de playoffs no puede ser mayor al total de equipos.",
                "warning"
            );

            return false;
        }

        return true;
    }

    async function saveData() {
    if (!validateForm()) {
        return;
    }

    const accessToken = getAccessToken();
    const accessUsername = getAccessUsername();

    if (!accessToken || !accessUsername) {
        showToast(
            "Tu sesión expiró. Inicia sesión nuevamente.",
            "danger"
        );

        router.push("/home", "root", "replace");

        return;
    }

    const data = {
        /*
            Los nombres enviados aquí se convierten en los
            nombres históricos que usa Info en el JSON.
        */
        fantasy: fantasy,
        name: leagueName.trim(),
        password: leaguePassword.trim(),
        teamName1: teamName.trim(),
        format: draftFormat,
        time: timePick,
        date: draftDay,
        hour: draftTime,
        order: draftOrder,
        teams: totalTeams,
        playoffs: playoffs
    };

    try {
        setSubmitting(true);

        const response = await fetch(
            "https://fantasy.ftblscore.com/create_league/" +
                "create_league.php",
            {
                method: "POST",
                credentials: "include",
                headers: {
                    "Content-Type": "application/json",
                    Accept: "application/json",
                    "X-Access-Token": accessToken,
                    "X-Access-Username": accessUsername
                },
                body: JSON.stringify(data)
            }
        );

        const rawResponse = await response.text();

        let result: {
            success?: boolean;
            message?: string;
            league?: {
                id?: string;
                name?: string;
            };
        };

        try {
            result = JSON.parse(rawResponse);
        } catch {
            console.error(
                "create_league.php no devolvió JSON:",
                rawResponse
            );

            throw new Error(
                "El servidor no devolvió una respuesta válida."
            );
        }

        if (!response.ok || !result.success) {
            throw new Error(
                result.message ||
                    "No fue posible crear la liga."
            );
        }

        showToast(
            result.message ||
                "Tu liga fue creada correctamente.",
            "success"
        );

        /*
            Se actualiza Fantasy.tsx al regresar porque volverá
            a consultar fantasy_data/{userId}.json.
        */
        window.setTimeout(function () {
            history.replace("/fantasy");
        }, 500);
    } catch (requestError) {
        console.error(
            "No fue posible crear la liga:",
            requestError
        );

        showToast(
            requestError instanceof Error
                ? requestError.message
                : "No fue posible crear la liga. Intenta nuevamente.",
            "danger"
        );
    } finally {
        setSubmitting(false);
    }
}


    useEffect(
        function () {
            if (!isAuthenticated()) {
                router.push("/home", "root", "replace");
            }
        },
        [router]
    );

    return (
        <IonPage>
            <IonHeader translucent>
                <IonToolbar className="create-league-toolbar">
                    <IonButton
                        slot="start"
                        fill="clear"
                        color="medium"
                        aria-label="Regresar a Fantasy"
                        onClick={function () {
                            history.replace("/fantasy");
                        }}

                    >
                        <IonIcon icon={arrowBackOutline} />
                    </IonButton>

                    <IonTitle>Crear liga</IonTitle>
                </IonToolbar>
            </IonHeader>

            <IonContent fullscreen className="create-league-content">
                <section className="create-league-hero">
                    <div className="create-league-hero__icon">
                        <IonIcon icon={trophyOutline} />
                    </div>

                    <div>
                        <span>NUEVA LIGA FANTASY</span>
                        <h1>Arma tu competencia</h1>
                        <p>
                            Configura tu draft e invita a otros managers.
                        </p>
                    </div>
                </section>

                <main className="create-league-main">
                    <section className="create-league-section">
                        <div className="create-league-heading">
                            <span className="create-league-heading__icon">
                                <IonIcon icon={trophyOutline} />
                            </span>

                            <div>
                                <span>INFORMACIÓN GENERAL</span>
                                <h2>Datos de la liga</h2>
                            </div>
                        </div>

                        <div className="create-league-card">
                            <IonItem
                                className="create-league-field"
                                lines="none"
                            >
                                <IonLabel position="stacked">
                                    Competencia
                                </IonLabel>

                                <IonSelect
                                    value={fantasy}
                                    interface="action-sheet"
                                    placeholder="Selecciona una competencia"
                                    onIonChange={function (event) {
                                        setFantasy(
                                            event.detail.value || ""
                                        );
                                    }}
                                >
                                    <IonSelectOption value="697bb47789dd5">
                                        LFA
                                    </IonSelectOption>

                                    <IonSelectOption value="69a0c6820e57d">
                                        14 Grandes
                                    </IonSelectOption>
                                </IonSelect>
                            </IonItem>

                            <IonItem
                                className="create-league-field"
                                lines="none"
                            >
                                <IonLabel position="stacked">
                                    Nombre de la liga
                                </IonLabel>

                                <IonInput
                                    value={leagueName}
                                    maxlength={20}
                                    placeholder="Ejemplo: Liga Norte"
                                    onIonChange={function (event) {
                                        setLeagueName(
                                            event.detail.value || ""
                                        );
                                    }}
                                />
                            </IonItem>

                            <p className="create-league-help">
                                Máximo 20 caracteres. Usa letras, números y
                                espacios.
                            </p>

                            <IonItem
                                className="create-league-field"
                                lines="none"
                            >
                                <IonIcon
                                    slot="start"
                                    icon={lockClosedOutline}
                                />

                                <IonLabel position="stacked">
                                    Contraseña de la liga
                                </IonLabel>

                                <IonInput
                                    value={leaguePassword}
                                    maxlength={20}
                                    type="password"
                                    placeholder="Contraseña para invitados"
                                    onIonChange={function (event) {
                                        setLeaguePassword(
                                            event.detail.value || ""
                                        );
                                    }}
                                />
                            </IonItem>

                            <p className="create-league-help">
                                Los managers usarán esta contraseña para
                                unirse a tu liga.
                            </p>
                        </div>
                    </section>

                    <section className="create-league-section">
                        <div className="create-league-heading">
                            <span className="create-league-heading__icon">
                                <IonIcon icon={settingsOutline} />
                            </span>

                            <div>
                                <span>CONFIGURACIÓN DEL DRAFT</span>
                                <h2>Define la selección</h2>
                            </div>
                        </div>

                        <div className="create-league-card create-league-card--grid">
                            <IonItem
                                className="create-league-field"
                                lines="none"
                            >
                                <IonLabel position="stacked">
                                    Formato de draft
                                </IonLabel>

                                <IonSelect
                                    value={draftFormat}
                                    interface="action-sheet"
                                    onIonChange={function (event) {
                                        setDraftFormat(
                                            event.detail.value || "stand"
                                        );
                                    }}
                                >
                                    <IonSelectOption value="stand">
                                        Estándar
                                    </IonSelectOption>
                                </IonSelect>
                            </IonItem>

                            <IonItem
                                className="create-league-field"
                                lines="none"
                            >
                                <IonLabel position="stacked">
                                    Tiempo por selección
                                </IonLabel>

                                <IonSelect
                                    value={timePick}
                                    interface="action-sheet"
                                    onIonChange={function (event) {
                                        setTimePick(
                                            event.detail.value || "30"
                                        );
                                    }}
                                >
                                    <IonSelectOption value="15">
                                        15 segundos
                                    </IonSelectOption>

                                    <IonSelectOption value="30">
                                        30 segundos
                                    </IonSelectOption>

                                    <IonSelectOption value="40">
                                        40 segundos
                                    </IonSelectOption>

                                    <IonSelectOption value="60">
                                        60 segundos
                                    </IonSelectOption>
                                </IonSelect>
                            </IonItem>

                            <IonItem
                                className="create-league-field"
                                lines="none"
                            >
                                <IonIcon
                                    slot="start"
                                    icon={calendarOutline}
                                />

                                <IonLabel position="stacked">
                                    Fecha del draft
                                </IonLabel>

                                <IonInput
    value={draftDay}
    type="date"
    min={getTodayDate()}
    onIonChange={function (event) {
        setDraftDay(
            event.detail.value || ""
        );
    }}
/>

                            </IonItem>

                            <IonItem
                                className="create-league-field"
                                lines="none"
                            >
                                <IonLabel position="stacked">
                                    Hora del draft
                                </IonLabel>

                                <IonSelect
                                    value={draftTime}
                                    interface="action-sheet"
                                    onIonChange={function (event) {
                                        setDraftTime(
                                            event.detail.value || "18"
                                        );
                                    }}
                                >
                                    <IonSelectOption value="9">
                                        9:00 a. m. CT
                                    </IonSelectOption>
                                    <IonSelectOption value="10">
                                        10:00 a. m. CT
                                    </IonSelectOption>
                                    <IonSelectOption value="11">
                                        11:00 a. m. CT
                                    </IonSelectOption>
                                    <IonSelectOption value="12">
                                        12:00 p. m. CT
                                    </IonSelectOption>
                                    <IonSelectOption value="13">
                                        1:00 p. m. CT
                                    </IonSelectOption>
                                    <IonSelectOption value="14">
                                        2:00 p. m. CT
                                    </IonSelectOption>
                                    <IonSelectOption value="15">
                                        3:00 p. m. CT
                                    </IonSelectOption>
                                    <IonSelectOption value="16">
                                        4:00 p. m. CT
                                    </IonSelectOption>
                                    <IonSelectOption value="17">
                                        5:00 p. m. CT
                                    </IonSelectOption>
                                    <IonSelectOption value="18">
                                        6:00 p. m. CT
                                    </IonSelectOption>
                                    <IonSelectOption value="19">
                                        7:00 p. m. CT
                                    </IonSelectOption>
                                    <IonSelectOption value="20">
                                        8:00 p. m. CT
                                    </IonSelectOption>
                                    <IonSelectOption value="21">
                                        9:00 p. m. CT
                                    </IonSelectOption>
                                    <IonSelectOption value="22">
                                        10:00 p. m. CT
                                    </IonSelectOption>
                                </IonSelect>
                            </IonItem>

                            <IonItem
                                className="create-league-field create-league-field--full"
                                lines="none"
                            >
                                <IonLabel position="stacked">
                                    Orden de selección
                                </IonLabel>

                                <IonSelect
                                    value={draftOrder}
                                    interface="action-sheet"
                                    onIonChange={function (event) {
                                        setDraftOrder(
                                            event.detail.value || "snake"
                                        );
                                    }}
                                >
                                    <IonSelectOption value="snake">
                                        Serpiente
                                    </IonSelectOption>

                                    <IonSelectOption value="linear">
                                        Lineal
                                    </IonSelectOption>
                                </IonSelect>
                            </IonItem>
                        </div>
                    </section>

                    <section className="create-league-section">
                        <div className="create-league-heading">
                            <span className="create-league-heading__icon">
                                <IonIcon icon={peopleOutline} />
                            </span>

                            <div>
                                <span>PARTICIPANTES</span>
                                <h2>Equipos y playoffs</h2>
                            </div>
                        </div>

                        <div className="create-league-card create-league-card--grid">
                            <IonItem
                                className="create-league-field"
                                lines="none"
                            >
                                <IonLabel position="stacked">
                                    Total de equipos
                                </IonLabel>

                                <IonSelect
                                    value={totalTeams}
                                    interface="action-sheet"
                                    onIonChange={function (event) {
                                        setTotalTeams(
                                            event.detail.value || "8"
                                        );
                                    }}
                                >
                                    <IonSelectOption value="4">
                                        4 equipos
                                    </IonSelectOption>
                                    <IonSelectOption value="5">
                                        5 equipos
                                    </IonSelectOption>
                                    <IonSelectOption value="6">
                                        6 equipos
                                    </IonSelectOption>
                                    <IonSelectOption value="7">
                                        7 equipos
                                    </IonSelectOption>
                                    <IonSelectOption value="8">
                                        8 equipos
                                    </IonSelectOption>
                                </IonSelect>
                            </IonItem>

                            <IonItem
                                className="create-league-field"
                                lines="none"
                            >
                                <IonLabel position="stacked">
                                    Equipos en playoffs
                                </IonLabel>

                                <IonSelect
                                    value={playoffs}
                                    interface="action-sheet"
                                    onIonChange={function (event) {
                                        setPlayoffs(
                                            event.detail.value || "0"
                                        );
                                    }}
                                >
                                    <IonSelectOption value="0">
                                        Sin playoffs
                                    </IonSelectOption>
                                    <IonSelectOption value="2">
                                        2 equipos
                                    </IonSelectOption>
                                    <IonSelectOption value="4">
                                        4 equipos
                                    </IonSelectOption>
                                </IonSelect>
                            </IonItem>
                        </div>
                    </section>

                    <section className="create-league-section">
                        <div className="create-league-heading">
                            <span className="create-league-heading__icon">
                                <IonIcon icon={americanFootballOutline} />
                            </span>

                            <div>
                                <span>TU EQUIPO</span>
                                <h2>Elige tu nombre</h2>
                            </div>
                        </div>

                        <div className="create-league-card">
                            <IonItem
                                className="create-league-field"
                                lines="none"
                            >
                                <IonLabel position="stacked">
                                    Nombre de tu equipo
                                </IonLabel>

                                <IonInput
                                    value={teamName}
                                    maxlength={20}
                                    placeholder="Ejemplo: Osos del Norte"
                                    onIonChange={function (event) {
                                        setTeamName(
                                            event.detail.value || ""
                                        );
                                    }}
                                />
                            </IonItem>

                            <p className="create-league-help">
                                Este será el nombre con el que competirás en la
                                liga.
                            </p>
                        </div>
                    </section>

                    <section className="create-league-submit">
                        <div>
                            <IonIcon icon={checkmarkCircleOutline} />
                            <span>
                                Podrás invitar managers cuando tu liga esté
                                creada.
                            </span>
                        </div>

                        <IonButton
                            expand="block"
                            disabled={submitting}
                            onClick={saveData}
                        >
                            {submitting ? (
                                <>
                                    <IonSpinner name="crescent" />
                                    Creando liga...
                                </>
                            ) : (
                                <>
                                    Crear mi liga
                                    <IonIcon
                                        slot="end"
                                        icon={arrowForwardOutline}
                                    />
                                </>
                            )}
                        </IonButton>
                    </section>
                </main>
            </IonContent>
        </IonPage>
    );
};

export default CreateLeague;
